import Vue from 'vue'
import Vuex from 'vuex'
import localeModule from './modules/locale'
import Articles from './modules/articles'
import Fitlers from './modules/filter'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    locale: localeModule,
    article: Articles,
    filters: Fitlers
  }
})
